exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recommend_custom_page .config_wrapper>div label[data-v-970c7ee8]{width:70px}.recommend_custom_page .config_wrapper .input_wrapper[data-v-970c7ee8]{margin-left:0}\n", ""]);

// exports
